export default {
    key: "contact",
    basePath: '/contact',
    exclude: false,
  }
  